import { VueRenderer } from '@tiptap/vue-2'
import tippy from 'tippy.js'

import MentionList from './MentionList.vue'

// @-mention candidates come from the getter wired in by the host component
// (its live `userList`), never from global sessionStorage, so concurrent
// editors never share a suggestion source.
export default function createSuggestion(getUserList) {
  return {
    items: ({ query }) => {
      var userList = getUserList() || []
      return userList.filter((item) => item.fullName.toLowerCase().startsWith(query.toLowerCase()))
    },

    render: () => {
      let component
      let popup

      return {
        onStart: (props) => {
          component = new VueRenderer(MentionList, {
            // using vue 2:
            parent: this,
            propsData: props
            // using vue 3:
            // props,
            // editor: props.editor
          })

          if (!props.clientRect) {
            return
          }

          popup = tippy('body', {
            getReferenceClientRect: props.clientRect,
            appendTo: () => document.body,
            content: component.element,
            showOnCreate: true,
            interactive: true,
            trigger: 'manual',
            placement: 'bottom-start'
          })
        },

        onUpdate(props) {
          component.updateProps(props)

          if (!props.clientRect) {
            return
          }

          popup[0].setProps({
            getReferenceClientRect: props.clientRect
          })
        },

        onKeyDown(props) {
          if (props.event.key === 'Escape') {
            popup[0].hide()

            return true
          }

          return component.ref.onKeyDown(props)
        },

        onExit() {
          popup[0].destroy()
          component.destroy()
        }
      }
    }
  }
}
